/**
 * Indian financial-year helpers.
 * The Indian FY runs from 1-Apr to 31-Mar.
 *   • Apr–Dec  → FY label uses (year - year+1)         e.g. FY 2025-26 starting 1-Apr-2025
 *   • Jan–Mar  → still belongs to the previous calendar year's FY label.
 */

const pad = (n) => String(n).padStart(2, '0');
const iso = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;

/**
 * Compute the financial year that a given JS Date belongs to.
 * @param {Date} [date]
 * @returns {{ start: string, end: string, startDate: Date, endDate: Date, label: string, shortLabel: string }}
 */
export function getFYForDate(date = new Date()) {
  const y = date.getFullYear();
  const m = date.getMonth(); // 0-indexed (0=Jan, 3=Apr)
  // If month is Jan/Feb/Mar (0,1,2), the FY started on 1-Apr of (y-1).
  const startYear = m < 3 ? y - 1 : y;
  const endYear = startYear + 1;
  const start = iso(startYear, 4, 1);
  const end = iso(endYear, 3, 31);
  return {
    start,
    end,
    startDate: new Date(start + 'T00:00:00'),
    endDate: new Date(end + 'T23:59:59'),
    label: `FY ${startYear}-${String(endYear).slice(-2)}`,
    shortLabel: `${startYear}-${String(endYear).slice(-2)}`,
  };
}

/** Convenience: current FY based on today. */
export function getCurrentFY() {
  return getFYForDate(new Date());
}
